<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="detailsPersonModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="detailsPersonModalLabel">{{$t('person.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <person-details-card v-model="model"
                                         v-if="showDetails"
                                         :allowEdit="allowEdit"
                                         @edit="onEdit"
                                         @cancel="onCancel">
                    </person-details-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '../../models/models';
    import PersonDetailsCard from './PersonDetailsCard';

    export default {
        components: {
            PersonDetailsCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
            allowEdit: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                showDetails: false,
                model: new Person(),
            };
        },
        methods: {
            onEdit() {
                this.$emit('onClose', { ...this.model });
                this.$emit('onEdit', { ...this.model });
                this.model = new Person();
            },
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Person();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Person(this.value);
                    this.showDetails = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
